import React, { useState, useEffect } from 'react';
import Select from "react-select";
import useAxios from 'hooks/useAxios';
import {
	Button,
	Modal,
	ModalHeader,
	ModalBody,
	ModalFooter,
	Form,
	FormGroup,
	Label,
	Input,
	Row,
	Col,
	InputGroup,
    InputGroupText
} from 'reactstrap';
import { cloneDeep, find } from 'lodash';
import { Formik, Field } from 'formik';
import FormikSelectField from "components/common/Fields/FormikSelectField";
import { toast } from 'react-toastify';
import * as Yup from 'yup';
import FormikDatePicker from 'components/common/Fields/FormikDatePicker';
import FormikInputField from 'components/common/Fields/FormikInputField';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlusCircle, faClose } from '@fortawesome/free-solid-svg-icons';
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import Calendar from 'assets/icon/calendar-icon.svg';
import { dateFormate } from 'utils/columns';
import Confirm from 'components/Confirm';
import cancel from 'assets/icon/cancel.svg';
import Add from 'assets/icon/Add-White-Icon.svg'
import { interpolateWarm } from 'd3';

const initialValues = {
	coveredEntity: {},
	wholesalerID: '',
	contractTermDate: '',
	contractStartDate:'',
	contractStatus: '',
	pharmacy: '',
	npi: '',
	accNumber:'',
};


let hasDatePopupOpen = false;
const validationSchema = Yup.object({
	wholesalerID: Yup.string().required('Wholesaler is required'),
	contractStartDate: Yup.string().required('Contract Start Date is required'),
	pharmacy: Yup.string().required('Pharmacy is required'),
	npi: Yup.string().required('Pharmacy Npi is required'),
	accNumber:Yup.string().required('Account # is required'),
});

const AddContractModal = ({ isOpen, toggle, thirdPartyAdmin }) => {
	const [state, updateState] = useState({
		rows: []
	});
	const API = useAxios();
	const [isConfirm, setConfirm] = useState(false);
	const [loading, setLoading] = useState(false);
	const [ceData, setCEData] = useState([]);
	const [selectedCE, setSelectedCE] = useState(" ");
	const [opaCode, setopaCode] = useState("");
	const [CECode, setCECode] = useState("");
	const [isSubmitting, setSubmitting] = useState(true);
	const [enableAdd, setenableAdd] = useState(true);
    const [contractStartDate, setStartDate] = useState('');
    const [contractTermDate, setEndDate] = useState('');
	const [selectedWholesaler,setSelectedWh]=useState('');
	const [phData, setPHData] = useState([]);
	const [selectedPH, setSelectedPH] = useState('');
	const [npi, setNPI] = useState(null);
	const [pharmacy, setPharmacy] = useState("");
	const[wholesalers,setwholesalers]=useState([]);
    const [contractList, setContractList] = useState([]);
    const [resultData, setResultData] = useState([]);	
    const [hideRow, setHideRow] = useState(false);
    const [showResultRow, setShowResultRow] = useState(true);
	const [accNumber,setWhAcc]=useState();

	const setState = (obj) => updateState((pre) => ({ ...pre, ...obj }));

	useEffect(() => {
		setSelectedCE(null);
		handleReset();
		setContractList([]);
	  }, []);

	 const handleSubmit = (val, actions) => {		
		const { resetForm, setSubmitting } = actions;
        var lst = {};
		lst.ThirdPartyAdminID=thirdPartyAdmin.thirdPartyAdminID;
        lst.PharmacyID = selectedPH.id;
		lst.PharmacyNPI=selectedPH.npidescription;
		lst.PharmacyName=selectedPH.phdescription;
        lst.CoveredEntityID = selectedCE.id;
        lst.StartDate = contractStartDate;
		lst.EndDate=contractTermDate;
		lst.WholesalerID=selectedWholesaler.wholesalerID;
		lst.Wholesaler=selectedWholesaler.wholeSalerName;
		lst.WholesalerAccount=accNumber;
        if (contractList.length > 0) {
            let cCheck = contractList.filter(m => m.PharmacyID == lst.PharmacyID);
            if (cCheck.length == 0) {
                setContractList(old => [...old, lst]);
            }
            else {
                toast.error('Duplicate entry not allowed.');
            }
        }
        else {
            setContractList(old => [...old, lst]);
        }
		handleReset();		
		resetForm();
		setSubmitting(false);
	};

	const { rows } = state;

	useEffect(() => {
		fetchWholesalers();
	  }, []);
	
	  const fetchWholesalers = async () => {
		try {
		  const { data } = await API.get('GWConfig/ThirdPartyAdmin/wholesalersList', {
			hasDefaultURL: true,
		  });
		  if (data) {
			setwholesalers(data);
		  } else {
			setwholesalers([]);
		  }
		} catch (error) {}
	  };


	const handleCEChange = async (value) => {
		setCECode(value);
		if (!value) return null;
		try {
			const result = await API.get(`GWConfig/coveredEntity/All/${value}`, {
				hasDefaultURL: true,
				hideLoader: true,
			});
			if (result?.data?.length > 0) {
				setCEData(result.data);
			} else {
				setCEData([]);
			}
		} catch (error) {
		}
	};
	const handleOPAChange = async (value) => {
		setopaCode(value);
		if (!value) return null;
		try {
			const result = await API.get(`GWConfig/coveredEntity/All/${value}`, {
				hasDefaultURL: true,
				hideLoader: true,
			});
			if (result?.data?.length > 0) {
				setCEData(result.data);
			} else {
				setCEData([]);
			}
		} catch (error) {
		}
	};

	const handlePHChange = async (value) => {
		setPharmacy(value);
		if (!value) return null;
		try {
			const result = await API.get(`GWConfig/Pharmacy/All/${value}`, {
				hasDefaultURL: true,
				hideLoader: true,
			});
			if (result?.data?.length > 0) {
				setPHData(result.data);
			} else {
				setPHData([]);
			}
		} catch (error) {
		}
	};
	const handleNPIChange = async (value) => {
		setNPI(value);
		if (!value) return null;
		try {
			const result = await API.get(`GWConfig/Pharmacy/All/${value}`, {
				hasDefaultURL: true,
				hideLoader: true,
			});
			if (result?.data?.length > 0) {
				setPHData(result.data);
			} else {
				setPHData([]);
			}
		} catch (error) {
		}
	};

	const onHandleDelete = (id) => {
		const updatedRows = rows.filter((item) => item.id !== id);
		setState({
			rows: updatedRows
		});
	};

	const handleStartDate = (setFieldValue,startDate) => {
        let stDate = dateFormate(startDate);
        setStartDate(stDate);
		
		setFieldValue('contractStartDate', startDate);
    };
	const handleTermDate = (startDate) => {
        let stDate = dateFormate(startDate);
        setEndDate(stDate);
    };

	const handleDateClick = (id) => {
        if (hasDatePopupOpen) {
            hasDatePopupOpen = false;
            return;
        }
        const calendarButton = document.getElementById(id);
        if (calendarButton) {
            calendarButton.click();
            hasDatePopupOpen = true;
        }
    };

    const handleMouseLeave = () => {
        hasDatePopupOpen = false;
    };

	const handleWhChange=({ target: { value } },setFieldValue)=>{
		if (value) {
			const findObj = find(wholesalers, {
			  wholesalerID: parseInt(value),
			});
			setSelectedWh(findObj);
			setFieldValue('wholesalerID',value);
		}
	};

	const onSelectCE = (ce) => {
		setSelectedCE(ce);
		setenableAdd(false);
	};
	const onSelectPH = (ph,setFieldValue) => {
		setFieldValue('pharmacy', ph.id);		
		setFieldValue('npi', ph.id);		
		setSelectedPH(ph);
	};

	const handleReset = () => {
        setStartDate('');
        setSelectedPH('');
		setEndDate('');
		setSelectedWh('');
    };

	const handletoggle=()=>{
		setSelectedCE('');
		handleReset();		
		setContractList([]);
		setResultData([]);
		setHideRow(false);
		setShowResultRow(true);
		toggle();
	}
	let addDisabled = (contractList.length > 0) ? false : true;
	const handleSaveConfirmation = () => {
        setConfirm(!isConfirm);
    };
	const handleAccOnChange = ({ target: { value } }) => {
		setWhAcc(value)
	  };

	const handleContractsSubmit = async () => {
        handleSaveConfirmation();
        setLoading(true);
        let payload = {};
        payload = contractList;
        try {
            const result = await API.post(
                `GWConfig/Contracts/addcontract`,
                payload, {
					hasDefaultURL: true,
				  });
            toast.success('Contract saved successfully');
            if (result?.data?.length > 0) {
                setResultData(old => ([...old,...result.data]));
                setHideRow(true);
				console.log(resultData);
                setShowResultRow(false);
                setLoading(false);
            }
        } catch (error) {
            console.log(error);
            setLoading(false);
        }

        setLoading(false);
    }

	return (
		<div>
			<Modal isOpen={isOpen} toggle={handletoggle} size="xxl">
				<ModalHeader toggle={handletoggle}>Add New Contract</ModalHeader>
				<ModalBody style={{ minHeight: 200 }}>
					<Formik>
						<Row hidden={hideRow}>
							<Col md={2} sm={3} xs={6}>
								<Label for="opaidSearch">Third Party Administrator</Label>
								<div>
									<b className='d-inline-block ps-2 font-weight-300'>
										{`${thirdPartyAdmin.thirdPartyAdminName || '-'} `}
									</b>
								</div>
							</Col>
							<Col md={2} sm={3} xs={6}>
								<FormGroup>
									<Label for="opaidSearch">OPAID Search</Label>
									<Select
										className="form-field-large inner-shadow-field required"
										classNamePrefix="select"
										IndicatorSeparator
										isSearchable={true}
										placeholder="Enter OPAID #"
										name="color"
										options={ceData}
										value={selectedCE || ''}
										inputValue={opaCode}
										onInputChange={handleOPAChange}
										onChange={onSelectCE}
										getOptionLabel={(option) => option.opadescription}
										getOptionValue={(option) => option.id}
										components={{
											DropdownIndicator: () => null,
											IndicatorSeparator: () => null,
										}}
										styles={{
											menu: (provided) => ({
												...provided,
												zIndex: 99,
											}),
										}}
									/>

								</FormGroup>
							</Col>

							<Col md={2} sm={3} xs={6}>
								<FormGroup>
									<Label for="entity">Covered Entity</Label>
									<Select
										className="form-field-large inner-shadow-field required"
										classNamePrefix="select"
										IndicatorSeparator
										isSearchable={true}
										placeholder="Enter CE Name"
										name="color"
										options={ceData}
										value={selectedCE || ''}
										inputValue={CECode}
										onInputChange={handleCEChange}
										onChange={onSelectCE}
										getOptionLabel={(option) => option.cedescription}
										getOptionValue={(option) => option.id}
										components={{
											DropdownIndicator: () => null,
											IndicatorSeparator: () => null,
										}}
										styles={{
											menu: (provided) => ({
												...provided,
												zIndex: 99,
											}),
										}}
									/>
								</FormGroup>
							</Col>
							<Col md={2} sm={3} xs={6}>
							</Col>
							<Col md={2} sm={3} xs={6}>
							</Col>
							<Col md={1} sm={1} xs={4}>
							</Col>
							<Col md={1} sm={2} xs={4}>
							</Col>
						</Row>
					</Formik>
					<hr />
					<Row hidden={true} className="align-items-center justify-content-between mb-2">
						<Col>
							<h5 className="f-15 text-primary font-weight-700">Pharmacy Selection</h5>
						</Col>
						<Col xs="auto">
							<Button size="sm" color="info" className="ms-auto" disabled>
								IMPORT DATA
							</Button>
						</Col>
					</Row>
					<Row hidden={hideRow}>
					
			<div className="table-card ndc_info">
				<div className='table-responsive'>
					<table className="table theme-table">
						<thead style={{ borderRadius: "5px" }}>
								<tr>
									<th width="140">Pharmacy NPI</th>
									<th width="300">Pharmacy Name</th>
									<th>Contract Start Date</th>
									<th>Contract Term Date</th>
									<th>Wholesaler</th>
									<th>Account #</th>
									<th> </th>
								</tr>
							</thead>
							<tbody>
								<Formik
									onSubmit={handleSubmit}
									initialValues={initialValues}
									validationSchema={validationSchema}
									enableReinitialize={true}
									children={(props) => {
										const { isSubmitting,resetForm, handleSubmit, setSubmitting ,setFieldValue,errors,touched} = props;
										return (
											<tr>
												<td>
													<Select
														className="form-field-large inner-shadow-field required"
														classNamePrefix="select"
														IndicatorSeparator
														isSearchable={true}
														placeholder="Enter NPI"
														name="color"
														options={phData}
														value={selectedPH || ''}
														inputValue={npi}
														onInputChange={handleNPIChange}
														onChange={(value)=>onSelectPH(value,setFieldValue)}
														getOptionLabel={(option) => option.npidescription}
														getOptionValue={(option) => option.id}
														components={{
															DropdownIndicator: () => null,
															IndicatorSeparator: () => null,
														}}
														styles={{
															menu: (provided) => ({
																...provided,
																zIndex: 99,
															}),
														}}
													/>
													{errors.npi ? (
														<div className="text-danger f-10 position-absolute">
															{errors.npi}
														</div>
													) : null}
												</td>
												<td>
													<Select
														className="form-field-large inner-shadow-field required"
														classNamePrefix="select"
														IndicatorSeparator
														isSearchable={true}
														placeholder='Enter Store # Or PH Name'
														name="color"
														options={phData}
														value={selectedPH ||''}
														inputValue={pharmacy}
														onInputChange={handlePHChange}
														onChange={(value)=>onSelectPH(value,setFieldValue)}
														getOptionLabel={(option) => option.phdescription}
														getOptionValue={(option) => option.id}
														components={{
															DropdownIndicator: () => null,
															IndicatorSeparator: () => null,
														}}
														styles={{
															menu: (provided) => ({
																...provided,
																zIndex: 99,
															}),
														}}
													/>
													{errors.npi ? (
														<div className="text-danger f-10 position-absolute">
															{errors.pharmacy}
														</div>
													) : null}
												</td>
												<td>
													<InputGroup onMouseLeave={handleMouseLeave}>
														<Field
															type='text'
															id='contractStartDate'
															name='contractStartDate'
															className='required'
															portalId="root portal"
															autoComplete='off'
															placeholder='Select a date'
															value={contractStartDate}
															component={FormikDatePicker}
															onChange={(value)=>handleStartDate(setFieldValue,value)}
															onKeyDown={(e) => {
																e.preventDefault();
															}}
														/>
														<InputGroupText
															onClick={() => handleDateClick('contractStartDate')}
														>
															<img src={Calendar} alt='' />
														</InputGroupText>
													</InputGroup>
												</td>
												<td>
													<InputGroup onMouseLeave={handleMouseLeave}>
														<Field
															type='text'
															id='contractTermDate'
															name='contractTermDate'
															portalId="root portal"
															autoComplete='off'
															placeholder='Select a date'
															value={contractTermDate}															component={FormikDatePicker}
															onChange={handleTermDate}
															onKeyDown={(e) => {
																e.preventDefault();
															}}
														/>
														<InputGroupText
															onClick={() => handleDateClick('contractTermDate')}
														>
															<img src={Calendar} alt='' />
														</InputGroupText>
													</InputGroup>
												</td>
												<td>
													<Field
														id="wholesalerID"
														name="wholesalerID"
														type="text"
														className="required"
														value={selectedWholesaler.wholesalerID||''}
														onChange={(e) => handleWhChange(e,setFieldValue)}
														component={FormikSelectField}
														options={wholesalers}
														defaultoption='--Select--'
														keys={{
															id: 'wholesalerID',
															label: 'wholeSalerName',
														}}
													/>
												</td>
												<td>
													<Field
														id='accNumber'
														name='accNumber'
														className='required'
														type='number'
														placeholder="Enter Account #"
														autoComplete='off'
														value={accNumber}
														component={FormikInputField}
														onKeyUp={handleAccOnChange}
													/>
												</td>
												<td>
													<Button
														disabled={enableAdd}
														onClick={handleSubmit}
														type="submit"
														color="link"
													>
														<FontAwesomeIcon
															icon={faPlusCircle}
															className="text-primary f-22"
														/>
													</Button>
												</td>
											</tr>
										);
									}}
								/>
								{
									contractList.map((item, index) => (
										<tr key={item.PharmacyID}>
											<td>{item.PharmacyNPI}</td>
											<td>{item.PharmacyName}</td>
											<td>{item.StartDate}</td>
											<td>{item.EndDate}</td>
											<td>{item.Wholesaler}</td>
											<td>{item.WholesalerAccount}</td>
											<td></td>
										</tr>
									))
								}
							</tbody>
						</table>
					</div>
</div>
					</Row>
					
					<Row hidden={showResultRow}>
					<div className="table-card">
						<table className="theme-table table table-striped border-0 w-100">
							<thead>
								<tr>
									<th>Status</th>
									<th>Message</th>
									<th width="140">Pharmacy NPI</th>
									<th width="300">Pharmacy Name</th>
									<th>Contract Start Date</th>
									<th>Contract Term Date</th>
									<th>Wholesaler</th>
									<th>Account #</th>
								</tr>
							</thead>
							<tbody>
								{
									resultData.map((item, index) => (
										<tr key={item.pharmacyID}>
											<td>
												{item.success == true && "Success"}
												{item.success == false && "Duplicate Contract"}
											</td>
											<td>{item.message}</td>
											<td>{item.pharmacyNPI}</td>
											<td>{item.pharmacyName}</td>
											<td>{dateFormate(item.startDate)}</td>
											<td>{dateFormate(item.endDate)}</td>
											<td>{item.wholesaler}</td>
											<td>{item.wholesalerAccount}</td>
										</tr>
									))
								}
							</tbody>
						</table>
					</div>

					</Row>
					
				</ModalBody>
				<ModalFooter hidden={hideRow}>
						<Button color="primary"  className='reset'  onClick={handletoggle}>
							<span className='right_5'><img src={cancel} alt="" />{""}</span> Cancel
						</Button>{' '}
						<Button color="primary" className='search' disabled={addDisabled} onClick={handleSaveConfirmation}>
							 <span className="right_5">
										<img src={Add} alt="" />
									  </span>{" "}
							Add Contract
						</Button>
				</ModalFooter>
			</Modal>
			<Confirm
                isOpen={isConfirm}
                loading={loading}
                message='Are you sure you want to save?'
                onToggle={handleSaveConfirmation}
                onCancel={handleSaveConfirmation}
                onContinue={handleContractsSubmit}
            />
		</div>
	);
};

export default AddContractModal;
